module.exports = __webpack_public_path__ + "img/10883_L.a77b5f4d.png";